import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSafeOverridePopUpIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14H0V7Z",
		fill: "currentColor"
	})
});
export default SvgSafeOverridePopUpIcon;
